import { getData, queryString } from '@/util/Axios'

export const ApiEntities = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const all = async (params, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}?${queryString.stringify(params)}`)
    return result.data
  }

  const find = async (id, module = 'accommodations') => {
    if (!id) return {}
    const result = await axios.get(`/api/entities/${module}/${id}`)
    return result.data
  }

  const migrate = async (id, module = 'accommodations') => {
    if (!id) return {}
    const result = await axios.get(`/api/entities/${module}/${id}/migrate`)
    return result.data
  }

  const migrateMedia = async (id, module = 'accommodations') => {
    if (!id) return {}
    const result = await axios.get(`/api/entities/${module}/${id}/migrate-media`)
    return result.data
  }

  const entitiesGetSiteContent = async (id, module = 'accommodations', siteId, lang) => {
    if (!id) return {}
    const result = await axios.get(`/api/entities/${module}/${id}/content/${siteId}/${lang}`)
    return result.data
  }

  const getQualifiedSites = async (id, module = 'accommodations') => {
    if (!id) return {}
    const result = await axios.get(`/api/entities/${module}/${id}/qualitfied-sites`)
    return result.data
  }

  const entitiesAddSites = async (id, module = 'accommodations', payload) => {
    if (!id) return {}
    const result = await axios.post(`/api/entities/${module}/${id}/sites`, payload)
    return result.data
  }

  const entitiesRemoveSite = async (id, siteId, module = 'accommodations') => {
    if (!id) return {}
    const result = await axios.delete(`/api/entities/${module}/${id}/sites/${siteId}`)
    return result.data
  }

  const entitiesSaveSiteContent = async (id, module = 'accommodations', siteId, lang, payload) => {
    if (!id) return {}
    const result = await axios.post(`/api/entities/${module}/${id}/content/${siteId}/${lang}`, payload)
    return result.data
  }

  const save = async (id, module = 'accommodations', payload) => {
    const result = await axios.post(`/api/entities/${module}/${id}`, payload)
    return result.data
  }

  const savePayload = async (id, module = 'accommodations', payload) => {
    const result = await axios.post(`/api/entities/${module}/${id}/payload`, payload)
    return result.data
  }

  const saveSettings = async (id, module = 'accommodations', payload) => {
    const result = await axios.post(`/api/entities/${module}/${id}/settings`, payload)
    return result.data
  }

  return {
    entitiesAddSites,
    entitiesRemoveSite,
    entitiesFind: find,
    entitiesGetSiteContent,
    entitiesSaveSiteContent,
    entitiesMigrate: migrate,
    entitiesMigrateMedia: migrateMedia,
    entitiesGetQualifiedSites: getQualifiedSites,
    entitiesAll: all,
    entitiesSave: save,
    entitiesSaveSettings: saveSettings,
    entitiesSavePayload: savePayload,
  }
}
